import React, { Component } from "react";
import Styled from "styled-components";

import Hero from "./Components/Hero";
import Projects from "./Components/Projects";
import About from "./Components/About";
class App extends Component {
  render() {
    const App = Styled.div`
      display: flex;
      flex-direction: column;
      `;

    const Heading = Styled.h2`
    text-align: center;
    font-size: 3em;
    font-family: 'Bree Serif', serif;
    color: tomato;

    @media (max-width: 900px) {
      font-size: 2em;
  }
 
 @media (max-width: 700px) {
  font-size: 1.5em;
  }
    `;

    const Footer = Styled.footer`
      background: #383F45;
      color:#737A78;
      text-align: center;
      padding: 20px;
    
    `;

    return (
      <App>
        <Hero />
        <Heading>About</Heading>
        <About />
        <Heading>Projects</Heading>
        <Projects />
        <Footer>
          Made by Josué Pérez <i className="far fa-copyright fa-fw" /> 2018
        </Footer>
      </App>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js